const gradients = {
  TRANSPARENT_TO_WHITE: 'linear-gradient(90deg, #FFFFFF00, #FFFFFF)',
  GRAY_DIAGONAL_STRIPES: 'linear-gradient(45deg, rgba(39, 41, 46, 0.08) 9%, rgb(247, 247, 248) 9%, rgb(247, 247, 248) 50%, rgba(39, 41, 46, 0.08) 50%, rgba(39, 41, 46, 0.08) 59%, rgb(247, 247, 248) 59%, rgb(247, 247, 248) 100%)',
};

export default gradients;
